import React from 'react';
import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import Bullet from 'components/base/Bullet';
import styled from 'styled-components';
import Text from 'components/base/Text';
import moment from 'moment';
import {
  DATE_FORMAT,
  EMPTY_NUMBER,
  TRACKING
} from 'common/constants/constants';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import { getLastActivityPhrase, nullSafeGet } from 'common/utils/utils.js';
import { HyperLink } from 'components/base/HyperLink';
import Icon from 'components/base/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { getBranchStateTag } from './BranchStateTag';
import { SizedAvatar } from 'components/StyledAvatar.js';
import * as TrackingService from 'common/services/tracking.service';

const BranchStatusDot = styled(Bullet)`
  padding-left: 1.5rem;
`;

const PullRequestSection = ({ pullRequest }) => {
  return (
    <Flex direction='column' mt='x-small'>
      <Flex items='center'>
        <Icon name='prinitiated' color='nepal' size='x-small' />
        <Tooltip
          placement='top'
          title={
            <Flex items='center'>
              <Icon name='prinitiated' color='nepal' size='x-small' />
              <Text ml='0.5rem' size='medium'>
                View pull request on Git
              </Text>
            </Flex>
          }
        >
          <HyperLink
            ml='0.5rem'
            multiLineEllipsisAfter={1}
            target='_blank'
            href={pullRequest.html_url}
            color='chambray'
            onClick={() =>
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.PULSE,
                click_type: TRACKING.CLICK.UNMATCHED_PR
              })
            }
          >
            {pullRequest.title}
          </HyperLink>
        </Tooltip>
      </Flex>
      <Text color='osloGray' size='medium'>
        {moment(pullRequest.created_at).format(DATE_FORMAT)}
      </Text>
    </Flex>
  );
};

export const BranchNameColumn = ({ name, state, pullRequest, httpUrl }) => {
  return (
    <Flex direction='column' padding='medium'>
      <BranchStatusDot
        backgroundColor={
          state === 'deployed' || state === 'merged'
            ? 'malachite'
            : 'dodgerBlue'
        }
        width='0.65rem'
        height='0.65rem'
      >
        <HyperLink
          color='shark'
          multiLineEllipsisAfter={1}
          target='_blank'
          href={httpUrl}
        >
          {name}
        </HyperLink>
        {pullRequest && <PullRequestSection pullRequest={pullRequest} />}
        {getBranchStateTag(state, { mt: 'x-small' })}
      </BranchStatusDot>
    </Flex>
  );
};

export const LastActivityColumn = ({
  lastActivity,
  contributorsById,
  myAccount
}) => {
  const lastActivityProviderId = _.get(
    contributorsById[lastActivity.author_id],
    'extended_data.provider_id',
    null
  );
  const accountProviderId = nullSafeGet(
    myAccount,
    'settings.provider_id',
    EMPTY_NUMBER
  ).toString();

  return (
    <Flex items='center'>
      <SizedAvatar
        src={getContributorAvatarUrl({ id: lastActivity.author_id })}
        size='2.4rem'
      />
      <Text size='medium' lineHeight='3rem' ml='1rem'>
        {getLastActivityPhrase(
          accountProviderId,
          lastActivityProviderId,
          lastActivity,
          'author_id',
          contributorsById
        )}
      </Text>
    </Flex>
  );
};
